import React from 'react'
import { EXTEND_SKU, MATTRESS_REMOVAL_SKUS, imgixConfig } from '@/config/globals'
import styles from './styles.module.scss'
import PictureImgix from '../PictureImgix'
import classNames from 'classnames'

const ItemThumbnail = ({ cartItem, desktop }) => {
    const { sku, assets, name } = cartItem
    const imageClassNames = classNames(styles.thumbnail, {
        [`${styles.thumbnailDesktop}`]: desktop
    })

    if (MATTRESS_REMOVAL_SKUS.includes(sku)) {
        return (
            <img className={imageClassNames} src={imgixConfig.MATTRESS_REMOVAL_ICON} alt={name} />
        )
    }

    if (sku === EXTEND_SKU) {
        return (
            <img className={classNames(imageClassNames, styles.extendThumbnail)} src={cartItem.thumbnail} alt={name} />
        )
    }

    if (assets) {
        const { folder, filename } = assets[0]
        const widths = {
            mobile: 200,
            tablet: 200,
            desktop: 200
        }
        return (
            <PictureImgix
                folder={folder}
                name={filename}
                alt={name}
                className={imageClassNames}
                widths={widths}
            />
        )
    }

    return <img className={imageClassNames} src={imgixConfig.NO_IMAGE_AVAILABLE_ICON} alt={name} />
}

export default ItemThumbnail
